import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { mq } from 'mdlkit';
import { Warning } from '../../core/icons';
import { useTheme } from '../../core/hooks';

interface Props {
  message: string;
  iconColor?: string;
  iconSize?: string;
}

const IconWrapper = styled(`span`)`
  background: ${({ theme }) => theme.colors.red};
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;

  ${mq({
    padding: ['11px 7px', '4px 7px'],
  })}

  ${Warning} {
    position: relative;
    top: 1px;
  }
`;

const MessageWrapper = styled.span`
  display: inline-block;
  padding: 0 10px 0 40px;
`;
const ComponentWrapper = styled.div`
  position: relative;
`;
const ErrorMessageWithIconComponent: FunctionComponent<Props> = ({
  message,
  iconColor,
  iconSize,
  ...rest
}: Props) => (
  <ComponentWrapper {...rest}>
    <IconWrapper>
      <Warning
        color={iconColor || useTheme().colors.white}
        size={iconSize || 14}
      />
    </IconWrapper>{' '}
    <MessageWrapper>{message}</MessageWrapper>
  </ComponentWrapper>
);

const ErrorMessageWithIcon = styled(ErrorMessageWithIconComponent)`
  border-radius: 5px;
  overflow: hidden;
  background: ${({ theme }) => rgba(theme.colors.red, 0.15)};
  font-size: 12px;
  padding: 5px 0;
`;

export default ErrorMessageWithIcon;
